import { Component, OnInit, OnDestroy } from '@angular/core';
import { INDRAMybService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../../store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAExtraSidebar } from '../ancillaries/extra-sidebar.indra.abstract';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { EXTRAS_ANCILLARY_CARBON_OFFSET, SESSION_VAR_KEY_CURRENCY } from '@ibe.config';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRACarbonOffsetRequest } from '@ibe.models/carbon-offset.indra.model';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAGoogleAnalyticsService, EVENT_ACTION_ADD_CART, EVENT_PRODUCT_BRAND_CARBON_OFFSET, EVENT_ACTION_REM_CART } from '@ibe.services/google.analytics.indra.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';

@Component({
	selector: 'app-carbon-offset',
	templateUrl: './carbon-offset.indra.component.html',
	styleUrls: ['./carbon-offset.component.scss'],
	providers: [INDRACurrencyPipe],
})
export class INDRACarbonOffsetComponent extends INDRAExtraSidebar implements OnInit, OnDestroy {
	protected isAlive: boolean = true;
	carbonOffset: boolean;
	isLoading: boolean = false;

	carbonOffsets = null;
	booked_trip;
	currency: string;

	showAddError: boolean = false;
	showRemoveError: boolean = false;
	isModificationDisallowed: boolean = false;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		store: Store<fromStore.State>,
		protected indraBookingService: INDRABookingService,
		protected indraMybService: INDRAMybService,
		protected ibeAdminService: INDRAIbeAdminService,
		protected ancillariesSelectionSrv: INDRAAncillariesSelectionService,
		protected ancillariesShoppingCartSrv: INDRAAncillariesShoppingCartService,
		protected dateService: INDRADateService,
		protected googleAnalytics: INDRAGoogleAnalyticsService,
		protected bfmStorage: INDRABFMDataStorageService,
		protected ancillaryService: INDRAAncillariesService,
		private currencyService: INDRACurrencyService,
		storageService: INDRAStorageService,
		protected currencyPipe: INDRACurrencyPipe,
		protected paymentInfoService: PaymentService
	) {
		super(sidebarService, route, router, indraBookingService, indraMybService, ibeAdminService, ancillariesSelectionSrv,
			ancillariesShoppingCartSrv, EXTRAS_ANCILLARY_CARBON_OFFSET, dateService, googleAnalytics, storageService, store, currencyPipe, paymentInfoService);

		const thirdPartyAncillaries = this.bfmStorage.INDRA_getThirdPartyAncillaries();
		this.booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();

		const carbonOffset = thirdPartyAncillaries.find(bundle =>
			bundle.ancillaryList[0].type == EXTRAS_ANCILLARY_CARBON_OFFSET
		);

		if (carbonOffset) {
			this.carbonOffsets = carbonOffset.carbonOffsetProperties;
			this.currency = this.currencyService.INDRA_getCurrencySymbol(this.carbonOffsets.currency).unit;
		}

		this.carbonOffset = this.booked_trip.carbon_offset ? true : false;

		// get 'isBookingCreated' if existing in URL query params
		const isBookingCreatedParam = this.route.snapshot.paramMap.get('isBookingCreated');
		if (isBookingCreatedParam === 'true') {
			this.isModificationDisallowed = true;
		}
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	INDRA_handleClose() {
		this.sidebarService.closeSidebar();
	}

	INDRA_carbonOffsetChanged() {
		this.isLoading = true;
		this.carbonOffset = !this.carbonOffset;
		this.indraBookingService.INDRA_setExtraChanged('carbon_offset', this.carbonOffset);
		// note: please create a model for the request
		if (!this.booked_trip.carbon_offset && this.carbonOffset) {
			const request = {
				'provider': 'CARBON_OFFSET',
				'idReservation': 'CO_001',
				'description': 'carbon offset',
				'currency': this.carbonOffsets.currency,
				'amount': this.carbonOffsets.totalForAllPassenger,
				'status': 'OK',
				'bookableItemId': 'CO_001',
				'extraInfo': {
					'totalDistance': this.carbonOffsets.totalDistance,
					'co2Emissions': this.carbonOffsets.co2Emissions,
					'contributionPerPassenger': this.carbonOffsets.contributionPerPassenger,
					'segmentPrices': this.carbonOffsets.segmentPrices,
					'quoteId': this.carbonOffsets.quoteId,
					"totalCost": this.carbonOffsets.totalCost,
					"totalTax": this.carbonOffsets.totalTax,
				}
			};

			this.ancillaryService.INDRA_addExternalReservation(request, 'CARBON_OFFSET').subscribe(res => {

				if (res && res.status === '200' && res.reservations && res.reservations.CARBON_OFFSET) {
					this.isLoading = true;
					const booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
					booked_trip.carbon_offset = res.reservations.CARBON_OFFSET;
					this.bfmStorage.INDRA_setActiveBookedTrip(booked_trip);
					this.INDRA_registerGA_carbonOffset();
					this.paymentInfoService.setUpdateBookingTotals(true);
					this.INDRA_handleClose();
					this.isLoading = false;
				} else {
					this.paymentInfoService.setUpdateBookingTotals(true);
					this.showAddError = true;
					this.isLoading = false;
				}
			}, error => {
				this.paymentInfoService.setUpdateBookingTotals(true);
				if (error) {
					this.showAddError = true;
					this.isLoading = false;
				}
			});
		} else {
			this.ancillaryService.INDRA_removeExternalReservation('CARBON_OFFSET').subscribe(res => {
				if (res && res.status === '200') {
					const booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
					const bookedTripCarbonOffset = booked_trip.carbon_offset[0];
					booked_trip.carbon_offset = null;
					this.bfmStorage.INDRA_setActiveBookedTrip(booked_trip);
					this.paymentInfoService.setUpdateBookingTotals(true);
					this.INDRA_handleClose();
					this.isLoading = false;
				} else {
					this.paymentInfoService.setUpdateBookingTotals(true);
					this.showRemoveError = true;
					this.isLoading = false;
				}
			}, error => {
				this.paymentInfoService.setUpdateBookingTotals(true);
				if (error) {
					this.showRemoveError = true;
					this.isLoading = false;
				}
			});
		}

	}

	INDRA_registerGA_carbonOffset() {
		const activeBooking = this.bfmStorage.INDRA_getActiveBookedTrip();
		let eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(EVENT_PRODUCT_BRAND_CARBON_OFFSET, activeBooking.carbon_offset[0]);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_ADD_CART);
		this.googleAnalytics.INDRA_GA_addToCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
	}

	INDRA_removeGACarbonOffset(bookedTripCarbonOffset) {
		let eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(EVENT_PRODUCT_BRAND_CARBON_OFFSET, bookedTripCarbonOffset);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_REM_CART);
		this.googleAnalytics.INDRA_GA_removeFromCart(this.currency, eventDataLayerObject);
	}

}
